import {
    Navbar
} from '../classes/navbar';
/* Use named export from the same bootstrap entry as `import 'bootstrap'` in theme.js.
 * Importing `bootstrap/js/dist/collapse` separately registers a second document-level
 * collapse listener — each tap fires two toggles so the menu often cannot close. */
import { Collapse } from 'bootstrap';

(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const dropdownMenus = document.querySelectorAll('.navbar-nav .dropdown, .navbar-nav .dropend') || [];

        const NAVBAR_ACTIVE_CLASS = 'navbar-active';

        dropdownMenus.forEach((menuToggle) => {
            new Navbar(menuToggle);
        });

        document.querySelectorAll('.ili-nav-collapse').forEach((collapseEl) => {
            collapseEl.addEventListener('shown.bs.collapse', () => {
                if (window.matchMedia('(min-width: 992px)').matches) {
                    return;
                }
                document.body.classList.add(NAVBAR_ACTIVE_CLASS);
            });
            collapseEl.addEventListener('hidden.bs.collapse', () => {
                document.body.classList.remove(NAVBAR_ACTIVE_CLASS);
            });
        });

        document.querySelectorAll('.ili-nav-collapse').forEach((collapseEl) => {
            collapseEl.querySelectorAll('a.nav-link[href]').forEach((link) => {
                if (link.classList.contains('dropdown-toggle')) {
                    return;
                }
                link.addEventListener('click', () => {
                    if (window.matchMedia('(min-width: 992px)').matches) {
                        return;
                    }
                    const href = link.getAttribute('href');
                    if (!href || href === '#') {
                        return;
                    }
                    try {
                        Collapse.collapseInterface(collapseEl, 'hide');
                    } catch (err) {
                        collapseEl.classList.remove('show');
                    }
                    document.body.classList.remove(NAVBAR_ACTIVE_CLASS);
                });
            });
        });
    });
})();
